import React, { useEffect, useState } from "react";
import "./Dashboard.css";

const AgentLogs = () => {
  const [agentLogs, setAgentLogs] = useState([]);

  useEffect(() => {
    fetch("/dashboard/agent-logs", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setAgentLogs(data.agentLogs || []))
      .catch((err) => console.error("Error fetching agent logs:", err));
  }, []);

  const formatTime = (isoString) => {
    if (!isoString) return "-";

    const date = new Date(isoString);

    return date.toLocaleString("th-TH", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-card-horizontal">
        <div className="logs-section-horizontal">
          <h2 className="logs-title">Agent Login Logs</h2>

          <table className="logs-table">
            <thead className="logs-table-header">
              <tr>
                <th className="logs-table-head">Email</th>
                <th className="logs-table-head">Time</th>
                <th className="logs-table-head">Status</th>
              </tr>
            </thead>

            <tbody>
              {agentLogs.map((log) => (
                <tr key={log.id} className="logs-table-row">
                  <td className="logs-table-cell">{log.email}</td>
                  <td className="logs-table-cell">
                    {formatTime(log.login_time)}
                  </td>
                  <td className="logs-table-cell">
                    {Number(log.status) === 1 ? "Success" : "Failed"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AgentLogs;
